(() => {
  'use strict';

  if (window.__drImageLightboxReady) return;
  window.__drImageLightboxReady = true;

  let overlay;
  let dialog;
  let enlarged;
  let caption;
  let closeButton;
  let previousFocus = null;
  let pointerStart = null;
  let dragged = false;

  const isEligible = (img) => {
    if (!(img instanceof HTMLImageElement)) return false;
    if (img.closest('.dr-image-lightbox')) return false;
    if (img.closest('button, [role="button"], [data-dr-no-lightbox]')) return false;
    if (img.getAttribute('aria-hidden') === 'true') return false;
    if (img.width < 40 || img.height < 40) return false;
    return Boolean(img.currentSrc || img.src);
  };

  const markImages = (root = document) => {
    root.querySelectorAll('img').forEach((img) => {
      if (isEligible(img)) img.dataset.drLightboxReady = 'true';
    });
  };

  const build = () => {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'dr-image-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Enlarged image');
    overlay.innerHTML =
      '<div class="dr-image-lightbox__dialog">' +
        '<button class="dr-image-lightbox__close" type="button" aria-label="Close enlarged image">×</button>' +
        '<img class="dr-image-lightbox__image" alt="">' +
        '<div class="dr-image-lightbox__caption" aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(overlay);
    dialog = overlay.querySelector('.dr-image-lightbox__dialog');
    enlarged = overlay.querySelector('.dr-image-lightbox__image');
    caption = overlay.querySelector('.dr-image-lightbox__caption');
    closeButton = overlay.querySelector('.dr-image-lightbox__close');

    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay || event.target === dialog || event.target === enlarged) close();
    });
  };

  const open = (img) => {
    build();
    previousFocus = document.activeElement;
    const src = img.currentSrc || img.src;
    enlarged.src = src;
    enlarged.alt = img.alt || '';
    const label = img.alt || img.getAttribute('aria-label') || '';
    caption.textContent = label;
    caption.hidden = !label;
    overlay.classList.add('is-open');
    document.body.classList.add('dr-lightbox-open');
    closeButton.focus({ preventScroll: true });
  };

  function close() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('dr-lightbox-open');
    enlarged.removeAttribute('src');
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
  }

  document.addEventListener('pointerdown', (event) => {
    const img = event.target.closest && event.target.closest('img[data-dr-lightbox-ready="true"]');
    if (!img) return;
    pointerStart = { x: event.clientX, y: event.clientY };
    dragged = false;
  }, { passive: true });

  document.addEventListener('pointermove', (event) => {
    if (!pointerStart) return;
    if (Math.abs(event.clientX - pointerStart.x) > 8 || Math.abs(event.clientY - pointerStart.y) > 8) dragged = true;
  }, { passive: true });

  document.addEventListener('pointerup', () => {
    setTimeout(() => { pointerStart = null; }, 0);
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const img = event.target.closest && event.target.closest('img');
    if (!isEligible(img) || dragged) {
      dragged = false;
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    open(img);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
    if (event.key === 'Tab' && overlay && overlay.classList.contains('is-open')) {
      event.preventDefault();
      closeButton.focus();
    }
  });

  markImages();

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('img') && isEligible(node)) node.dataset.drLightboxReady = 'true';
        markImages(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
